import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import PageStructure from "flarum/forum/components/PageStructure";
import Page from "flarum/common/components/Page";
import HeaderBanner from "./components/HeaderBanner";
function bannerContainer() {
  return m("div", {
    className: "XgayBanners-container container"
  }, HeaderBanner.component());
}
app.initializers.add("xgay-banner", () => {
  extend(PageStructure.prototype, "mainItems", function (items) {
    if (app.current.matches("ext:fof/pages/forum/components/PagePage")) return;

    // A separate container before the sidebar/content container spans both columns.
    items.add("xgay-banner", bannerContainer(), 150);
  });

  // Some pages (such as NotificationsPage) render a plain root rather than PageStructure.
  extend(Page.prototype, "oninit", function () {
    extend(this, "view", function (view) {
      if (app.current.matches("ext:fof/pages/forum/components/PagePage")) return;
      if (view && typeof view === "object" && "tag" in view && typeof view.tag === "string" && Array.isArray(view.children)) {
        view.children.unshift(bannerContainer());
      }
    });
  });
});
export { default as HeaderBanner } from "./components/HeaderBanner";